import {FC, useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import Swal from 'sweetalert2'
import {PageTitle} from '../../../../../../_metronic/layout/core'
import {Button} from '../../../../../components/Button/Button'
import {Input} from '../../../../../components/Input/Input'
import {Loading} from '../../../../../components/Loading/Loading'
import {GET, PUT} from '../../../../../services/api'
import {i18n} from '../../../../../translate/i18n'
import {BreadCrumbs} from '../../../../../components/BreadCrumbs/breadCrumbrs'

const EditarCepContent: FC = () => {
  const navigate = useNavigate()
  const {id} = useParams()
  const [loading, setLoading] = useState(false)
  const [zipStart, setZipStart] = useState('')
  const [zipEnd, setZipEnd] = useState('')
  const [price, setPrice] = useState(0)

  const getCep = async () => {
    try {
      setLoading(true)
      const cepRes = await GET(`/zip-code/${id}`)
      let newCepStart = cepRes.data[0].zipStart.toString()
      let newCepEnd = cepRes.data[0].zipEnd.toString()
      if (newCepStart.length < 8) {
        let leftZeros = ''
        for (let i = 0; i < 8 - newCepStart.length; i++) {
          leftZeros += '0'
        }
        newCepStart = leftZeros + newCepStart
      }

      if (newCepEnd.length < 8) {
        let leftZeros = ''
        for (let i = 0; i < 8 - newCepEnd.length; i++) {
          leftZeros += '0'
        }
        newCepEnd = leftZeros + newCepEnd
      }
      setZipStart(`${newCepStart.substring(0, 5)}-${newCepStart.substring(5, 8)}`)
      setZipEnd(`${newCepEnd.substring(0, 5)}-${newCepEnd.substring(5, 8)}`)
      setPrice(cepRes.data[0].price)
      setLoading(false)
    } catch (e) {
      setLoading(false)
      console.log(e)
    }
  }

  const editZip = async () => {
    try {
      if (!zipStart || !zipEnd || zipStart.includes('_') || zipEnd.includes('_')) {
        Swal.fire({
          icon: 'error',
          title: 'Campos faltantes',
          text: 'Verifique se preencheu todos os campos!',
        })
      } else {
        setLoading(true)
        const cepRes = await PUT(`/zip-code/${id}`, {
          zipStart: parseInt(zipStart.replace('-', '')),
          zipEnd: parseInt(zipEnd.replace('-', '')),
          price: price,
          negativeRange: false,
        })
        setLoading(false)
        if (cepRes.success === true) {
          Swal.fire({
            icon: 'success',
            title: 'CEP alterado',
            text: 'Edição realizada com sucesso!',
          }).then(() => navigate('/configuracoes/taxa-entrega/cep'))
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Erro',
            text: 'Erro ao alterar CEP!',
          })
        }
      }
    } catch (e) {
      setLoading(false)
      console.log(e)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Erro ao alterar CEP!',
      })
    }
  }

  useEffect(() => {
    getCep()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>
                  {i18n.t(`delivery_fee.edit_cep`)}
                </span>
                <BreadCrumbs />
                <span className='text-muted mt-1 fw-bold fs-7'>
                  {i18n.t(`delivery_fee.save_changes_edit`)}
                </span>
              </h3>
            </div>
            <div className='card-body border-bottom'>
              <div className='d-flex justify-content-between align-items-center'>
                <div className='me-5 flex-grow-1'>
                  <Input
                    inputAttr={{
                      type: 'cep',
                    }}
                    placeholder={i18n.t(`delivery_fee.cep_start`)}
                    label={i18n.t(`delivery_fee.cep_start`)}
                    change={(value: string) => setZipStart(value)}
                    value={zipStart}
                  />
                </div>
                <div className='me-5 flex-grow-1'>
                  <Input
                    inputAttr={{
                      type: 'cep',
                    }}
                    placeholder={i18n.t(`delivery_fee.cep_end`)}
                    label={i18n.t(`delivery_fee.cep_end`)}
                    change={(value: string) => setZipEnd(value)}
                    value={zipEnd}
                  />
                </div>
                <div className='flex-grow-1'>
                  <Input
                    inputAttr={{
                      type: 'money',
                    }}
                    placeholder={i18n.t(`delivery_fee.value`)}
                    label={i18n.t(`delivery_fee.value`)}
                    currency='BRL'
                    locale='pt-BR'
                    change={(value: number) => setPrice(value)}
                    value={price}
                  />
                </div>
              </div>
            </div>
            <div className='d-flex w-100'>
              <div className='col-6 d-flex justify-content-start'>
                <Button
                  text={i18n.t(`buttons.back`)}
                  color='info'
                  size='small'
                  horizontalPadding={6}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => navigate(-1)}
                  btnClass='fw-bolder m-9'
                />
              </div>
              <div className='col-6  d-flex justify-content-end'>
                <Button
                  text={i18n.t(`buttons.save`)}
                  color='primary'
                  size='small'
                  horizontalPadding={6}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => editZip()}
                  btnClass='fw-bolder m-9'
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

const EditarCep: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {
            title: i18n.t(`delivery_fee.delivery_fee`),
            path: 'configuracoes/taxa-entrega/interno',
            isActive: true,
          },
          {
            title: i18n.t(`delivery_fee.cep_delivery`),
            path: 'configuracoes/taxa-entrega/cep',
            isActive: true,
          },
          {
            title: i18n.t(`general.edit`),
            path: 'configuracoes/taxa-entrega/cep/editar',
            isActive: true,
          },
        ]}
      >
        {i18n.t(`delivery_fee.edit_cep`)}
      </PageTitle>
      <EditarCepContent />
    </>
  )
}

export {EditarCep}
